<app-auth0-sdk-login
  domain="ag-doctors-dev.jp.auth0.com"
  clientID="OQA4up7LUjL0NV6olZCIlDShfw6Zkc39"
></app-auth0-sdk-login>
